import {DetailsList, FontSizes, FontWeights, IconButton, PrimaryButton, SelectionMode, Stack} from "@fluentui/react";
import {Link} from "react-router-dom";
import * as React from "react";

function ProjectDocumentList(props) {
    const columns = [
        {
            key: 'type',
            name: 'Typ Dokumentu',
            ariaLabel: 'Typ Dokumentu',
            fieldName: 'type',
            minWidth: 160,
            isRowHeader: true,
            isResizable: false,
            onRender: (item) => (<a href={`/api/public/uploaded/${item.filename}`} target={'_blank'} rel="noreferrer"><PrimaryButton text={item.type} /></a>)
        },
        {
            key: 'number',
            name: 'Numer',
            ariaLabel: 'Numer',
            fieldName: 'number',
            minWidth: 50,
            isResizable: false,
        },
        {
            key: 'created',
            name: 'Utworzono',
            ariaLabel: 'Utworzono',
            fieldName: 'created',
            minWidth: 120,
            isResizable: false,
        },
        {
            key: 'user',
            name: 'Użytkownik',
            ariaLabel: 'Użytkownik',
            fieldName: 'user',
            minWidth: 120,
            isResizable: true
        }
    ];
    if (props.history) {
        columns.push({
                key: 'id',
                name: 'Historia',
                ariaLabel: 'Historia Dokumentu',
                fieldName: 'id',
                minWidth: 40,
                isResizable: false,
                onRender: (item) => (<Link to={`/project/${item.project_id}/document/${item.id}`}><IconButton iconProps={ {iconName: 'FullHistory' }} title='Historia'/></Link>)
        });
    }
    if (props.data.length) {
        return (<Stack.Item>
            <h2 style={{fontSize: FontSizes.size24, fontWeight: FontWeights.light}}>{props.title}</h2>
            <DetailsList items={props.data} columns={columns} selectionMode={SelectionMode.none}/>
        </Stack.Item>);
    }
    return null;
}

ProjectDocumentList.defaultProps = {
    title: 'Dokumenty',
    history: true
}

export default ProjectDocumentList;